import { ComplianceEntityType, Person } from "@wingspanhq/wingspan-api-sdk";

export const selectorPersonDisplayName = (person: Person): string => {
  const complianceEntity = person.complianceEntity;

  if (complianceEntity) {
    if (complianceEntity.type === ComplianceEntityType.INDIVIDUAL) {
      const name = complianceEntity.individualLegalName;
      const fullName =
        name?.fullLegalName ||
        [name?.givenName, name?.familyName].filter(Boolean).join(" ");

      if (fullName) {
        return fullName;
      }
    } else if (complianceEntity.doingBusinessAs || complianceEntity.legalName) {
      return (complianceEntity.doingBusinessAs ||
        complianceEntity.legalName) as string;
    }

    if (complianceEntity.preferredName) {
      return complianceEntity.preferredName;
    }
  }

  return person.email || "";
};
